(function(){
  function initTracking(section){
    const form = section.querySelector('[data-go-track-form]');
    const input = section.querySelector('[data-go-track-input]');
    const message = section.querySelector('[data-go-track-message]');
    const current = section.querySelector('[data-go-track-current]');
    const date = section.querySelector('[data-go-track-date]');
    const timeline = section.querySelector('[data-go-track-timeline]');

    if(!form || !input) return;

    form.addEventListener('submit', function(e){
      e.preventDefault();
      const value = (input.value || '').trim();

      if(!value){
        message.hidden = false;
        message.textContent = 'Ingresá tu número de pedido para consultar el estado.';
        return;
      }

      message.hidden = false;
      message.textContent = 'Modo demo activo. Cuando conectemos la API, esta consulta devolverá el estado real del envío.';
      current.textContent = 'Consulta preparada';
      date.textContent = new Date().toLocaleString('es-AR', { dateStyle:'short', timeStyle:'short' });

      timeline.innerHTML = `
        <div class="go-track-step is-complete">
          <span></span>
          <div><strong>Pedido identificado</strong><p>Referencia ingresada: ${escapeHtml(value)}</p></div>
        </div>
        <div class="go-track-step is-current">
          <span></span>
          <div><strong>Esperando conexión API</strong><p>Al activar el backend se consultará Shopify y luego Correo Argentino PAQ.AR.</p></div>
        </div>
      `;
    });
  }

  function escapeHtml(str){
    return str.replace(/[&<>'"]/g, function(tag){
      const chars = {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'};
      return chars[tag] || tag;
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.go-track-section').forEach(initTracking);
  });
})();